import { gql } from "@apollo/client";

export const GET_INFO_EVALUATION_PERFORMANCE = gql`
 query GET_INFO_EVALUATION_PERFORMANCE($input: info_Evaluation_Performance) {
  GET_INFO_EVALUATION_PERFORMANCE(input: $input) {
    businessName
    campus
    competencies {
      idEval
      name
      idCompetencies
      idQual
      calificacion      
      nameCompetence
      DescriptionCompetence
    }
    active
    step
    dateAdmission
    email
    evaluationQualStatus
    idCollaboratorPerEval
    idEvaluator
    idEvalPerformance
    namePerformance
    description
    dateClose
    period
    project
  }
}
`;

export const CREATE_ADD_ANSWERS_PER_EVAL = gql`
  mutation CREATE_ADD_ANSWERS_PER_EVAL($input: [answers_Per_eval]) {
    CREATE_ADD_ANSWERS_PER_EVAL(input: $input)
   }
`;
